import { Col, Row } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { TICKET_ENUM, TICKET_NAME } from 'src/services/api/constant'
import useCheckIn from 'src/store/hooks/checkIn'
import { apiCheckIn } from 'src/store/sagas/checkIn'

export const CheckIn = () => {
  const token = localStorage.getItem('access_token')
  const [searchParams] = useSearchParams()
  const [ticketId, setTicketId] = useState(searchParams.get('ticketId'))
  const [ticketInfo, setTicketInfo] = useState(null)
  const [statusCheckIn, setStatusCheckIn] = useState(false)
  const navigate = useNavigate()

  if (!ticketId || !token) {
    navigate('/')
  }

  const { actions } = useCheckIn()
  // const

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const query = {
      ticketId,
    }
    const res = await apiCheckIn(query)
    if (res?.statusCode === 200) {
      setStatusCheckIn(true)
    } else {
      setStatusCheckIn(false)
    }
    setTicketInfo(res)
  }

  return (
    <>
      <Row gutter={24} className="mt-10 p-4">
        <div className="bg-white w-full pt-10 pb-10 rounded-lg">
          <Col span={24} className="text-black">
            {statusCheckIn && (
              <>
                <h2 className="text-3xl text-[#1677FF] text-center font-bold">
                  Check In vé thành công
                </h2>
                <h4 className="text-xl mt-4 text-center font-bold">
                  Thông tin vé
                </h4>
                <p className="text-md">
                  <span className="font-bold">
                    <span className="font-bold">Event:</span>
                  </span>{' '}
                  {TICKET_NAME[ticketInfo?.data.eventCode]}
                </p>
                <p className="text-md">
                  <span className="font-bold">Email:</span>{' '}
                  {ticketInfo?.data.email}
                </p>
                <p className="text-md">
                  <span className="font-bold">Khu vực:</span>{' '}
                  {ticketInfo?.data.areaCode}
                </p>
                <p className="text-md">
                  <span className="font-bold">Ghế:</span>{' '}
                  {ticketInfo?.data.seat?.join(', ')}
                </p>
                <p className="text-md">
                  <span className="font-bold">Order Info:</span>{' '}
                  {ticketInfo?.data.orderInfo}
                </p>
                <p className="text-md">
                  <span className="font-bold">Thời gian duyệt:</span>{' '}
                  {moment(ticketInfo?.data.createdAt).format(
                    'HH:mm:ss DD/MM/YYYY',
                  )}
                </p>
              </>
            )}
            {!statusCheckIn && (
              <>
                <h2 className="text-3xl text-[#ff4d4f] text-center font-bold">
                  Check In vé không thành công
                </h2>
                <h4 className="text-2xl font-bold text-center mt-2">
                  Thông tin Check-In: {ticketInfo?.message}
                </h4>
              </>
            )}
          </Col>
        </div>
      </Row>
    </>
  )
}
